/* Fresh reconstruction from measured homepage light fields and motion; no source bundle code. */
if (!customElements.get('mitoq-ambient-lights')) {
  customElements.define('mitoq-ambient-lights', class extends HTMLElement {
    connectedCallback() {
      if (this.context) return;
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas?.getContext('2d', { alpha: true });
      if (!this.context) return;
      this.direction = 1;
      this.resize = () => {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.redY = this.canvas.height / 2;
        this.direction = 1;
        this.paint();
      };
      this.tick = () => {
        this.frame = null;
        if (document.hidden || !this.isConnected) return;
        this.redY += this.direction * 3;
        if (this.redY > this.canvas.height * .9 || this.redY < this.canvas.height * .1) {
          this.direction *= -1;
        }
        this.paint();
        this.frame = requestAnimationFrame(this.tick);
      };
      this.visibility = () => {
        if (document.hidden) {
          if (this.frame !== null) cancelAnimationFrame(this.frame);
          this.frame = null;
        } else if (this.frame === null) {
          this.frame = requestAnimationFrame(this.tick);
        }
      };
      this.resize();
      this.setAttribute('data-ready', '');
      window.addEventListener('resize', this.resize);
      document.addEventListener('visibilitychange', this.visibility);
      this.frame = document.hidden ? null : requestAnimationFrame(this.tick);
    }

    paint() {
      const { width, height } = this.canvas;
      const radius = Math.max(width, height) * .8;
      const context = this.context;
      context.clearRect(0, 0, width, height);
      for (const [x, y, color] of [[0, this.redY, 'rgba(255,0,0,.4)'], [width, height - this.redY, 'rgba(0,50,220,.4)']]) {
        const light = context.createRadialGradient(x, y, 0, x, y, radius);
        light.addColorStop(0, color);
        light.addColorStop(1, 'rgba(0,0,0,0)');
        context.fillStyle = light;
        context.fillRect(0, 0, width, height);
      }
    }

    disconnectedCallback() {
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      window.removeEventListener('resize', this.resize);
      document.removeEventListener('visibilitychange', this.visibility);
      this.removeAttribute('data-ready');
      this.context = null;
      this.frame = null;
    }
  });
}
